"use strict";

import { D5SnackbarsConstants } from 'Constants/D5SnackbarsConstants';
import { AppDispatcher } from 'Dispatcher';
/**
 * @param {string} type
 * @param {string} message
 * @param {boolean} open
 */

export function showSnackBar(_ref) {
  var type = _ref.type,
      message = _ref.message,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open;
  AppDispatcher.asyncDispatch({
    actionType: D5SnackbarsConstants.SHOW_SNACKBAR,
    type: type,
    open: open,
    message: message
  });
}